<template>
    <div class="MikomiDataCell" :title="CellTitle" :style="`background-color: ${CellColor}; color: ${CellTextColor};`">
        {{ Value }}
    </div>
</template>

<script>
export default{
    props:{
        CellTitle: String,
        CellValue: String,
        CellColor: String,
        CellTextColor: String,
    },
    computed:{
        Value(){
            return this.CellValue === 'null' ? '' : this.CellValue;
        }
    }
}
</script>